// src/lib/richtext/useIsTouch.js
import { useEffect, useState } from 'react'

// "No hover" implies a touch-primary device. Some hybrids (Surface, iPad with mouse)
// register hover, which is what we want — they get the desktop UX.
const QUERY = '(hover: none), (pointer: coarse)'

export default function useIsTouch() {
  const [isTouch, setIsTouch] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false
    return window.matchMedia(QUERY).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia(QUERY)
    const handler = (e) => setIsTouch(e.matches)
    // Older Safari uses addListener; modern uses addEventListener.
    if (mql.addEventListener) mql.addEventListener('change', handler)
    else mql.addListener(handler)
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handler)
      else mql.removeListener(handler)
    }
  }, [])

  return isTouch
}
